module.exports = function(ratings) {
	"use strict";
  ratings
  .controller('ratingController', ratingController)
	ratingController.$inject = ["createRandomHash","authtokenService","API_URL","$timeout","$filter","keyPressOnlyNumber","$parse","$attrs","$rootScope","$scope","getDataService", "jQuery","$state", "$stateParams","refreshtokenService","config","reqursiveService","putDataService","alertService","postDataService","deleteDataService","serverError","offlineError"];
	
  function ratingController(createRandomHash,authtokenService,API_URL,$timeout,$filter,keyPressOnlyNumber,$parse,$attrs,$rootScope,$scope,getDataService,jQuery,$state, $stateParams,refreshtokenService, config, reqursiveService, putDataService, alertService,postDataService,deleteDataService,serverError,offlineError) {
    var vmrating = this;
    var validation = true;
    var parent = $scope.$eval($attrs.parent);
    vmrating.editStatusShow = false;
    vmrating.minimumNumberOfQuestion = false;
    vmrating.titleRequired = false;
    vmrating.dataVote = {};
    vmrating.keyPressOnlyNumber = keyPressOnlyNumber;
    vmrating.selectedType = {value: 'football'};
    vmrating.choices = [];
    vmrating.selectedRatingStatus = {};
    vmrating.required = {};
    var token = authtokenService.getToken();
    Dropzone.autoDiscover = false;
    vmrating.dzOptions = {
      url : API_URL + 'upload/ratings',
      paramName : 'photo',
      maxFilesize : '500',
      parallelUploads: 1,
      uploadMultiple: false,
      acceptedFiles : 'image/jpeg, images/jpg, image/png',
      addRemoveLinks : true,
      autoProcessQueue : false,
      dictInvalidFileType: 'This file type is not supported. Upload a JPEG or PNG image.',
      dictFileTooBig:'File size too Big. Maximum size is 500KB.',
      dictDefaultMessage : "Click or drop image here to upload",
      headers:{
        'x-auth': token  
      }
    };
    vmrating.dzCallbacks = {
      'addedfile' : function(file){
        // Only process the file if it's accepted
          vmrating.pendingUpload = true;
          if(vmrating.newFileRating) {
            vmrating.dzMethods.removeFile(vmrating.newFileRating);
          }
          vmrating.newFileRating = file;
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              token = authtokenService.getToken();
              vmrating.dzOptions.headers['x-auth'] = token;
              vmrating.dzMethods.processQueue();
            },
            function(error) {
              // report something
            },
            function(progress) {
              // report progress
          });
      },
      'success' : function(file, xhr, response){
        var data = JSON.parse(response.currentTarget.response);
        vmrating.choices.length = 0;
        if(data && data.data && data.data.data && data.data.data.results && data.data.data.results.length > 0) {
          for(var i=0; i<data.data.data.results.length;i++) {
            var choiceData = angular.copy(data.data.data.results[i]);
            choiceData._id = createRandomHash(10);
            vmrating.choices.push(choiceData);
            vmrating.required[choiceData._id] = {};
          }
          vmrating.pendingUpload = false;
        }
      },
      'error' : function(file,message) {
        vmrating.pendingUpload = false;
        if(message === vmrating.dzOptions.dictInvalidFileType) {
          jQuery(file.previewElement).find('.dz-error-message').text(vmrating.dzOptions.dictInvalidFileType)
          return
        } else if(message === vmrating.dzOptions.dictFileTooBig) {
          jQuery(file.previewElement).find('.dz-error-message').text(vmrating.dzOptions.dictFileTooBig)
          return
        }
          // console.log(response.xhr.status);
        if(message && message.error && message.error.message) {
          jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
        } else {
          jQuery(file.previewElement).find('.dz-error-message').text('Cannot POST /upload/rating');
        }
      }
    };
    vmrating.sortableOptions = {
      axis: 'y'
    }
    vmrating.editRatingStatus = function() {
      vmrating.editRatingStatusShow = true;
    }
    vmrating.changeRatingStatus = function() {
      vmrating.editRatingStatusShow = false;
      vmrating.dataRating.status = vmrating.selectedRatingStatus.value;
    }
    vmrating.cancelEditRatingStatus = function() {
      vmrating.editRatingStatusShow = false;
      vmrating.dataRating.status = vmrating.copyStatus;
    }
    vmrating.editRatingStatus = function() {
      vmrating.copyStatus = angular.copy(vmrating.selectedRatingStatus.value);  
      vmrating.editRatingStatusShow = true;
    }
    vmrating.submitEditRatingStatus = function() {
      vmrating.editRatingStatusShow = false;
    }
    vmrating.switchRatingStatus = function(status) {
      vmrating.dataRating.status = status;
    }
    vmrating.editRatingDate = function() {
      vmrating.editRatingDateShow = true;
      if(!vmrating.dataRating.expire_date) {
        convertTimeFunction(undefined);
      } 
    }
    vmrating.cancelEditRatingDate = function() {
      vmrating.editRatingDateShow = false; 
    }
    
    vmrating.setRatingDate = function() {
      vmrating.editRatingDateShow = false; 
      var dateArray = [vmrating.ratingYear, parseInt(vmrating.selectedRatingMonth.value)-1, vmrating.ratingDay, vmrating.ratingHours, vmrating.ratingMinutes];
      var updateDate = moment(dateArray).toISOString();
      if(moment.duration(moment(dateArray).diff(moment())).asMinutes()>60) {
        vmrating.dataRating.expire_date = $filter('date')(updateDate, "MMM d, y HH:mm");
        vmrating.editRatingDateShow = false
      } else {
        alertService('danger','Opps! ', 'The date is not valid. The set date must be at least 60 minutes from now.');
      }
    }
    function convertTimeFunction(date) {
      var a = moment(date);
      var year = a.format('YYYY');
      var month = a.format('M');
      var day = a.format('D');
      var hour = a.hours();
      var min = a.minutes();
      vmrating.ratingYear = year;
      vmrating.selectedRatingMonth = {value: month};
      vmrating.ratingDay = day;
      if(hour<10) {
        vmrating.ratingHours = '0'+hour;  
      } else {
        vmrating.ratingHours = hour;
      }
      if(min<10) {
        vmrating.ratingMinutes = '0'+min;  
      } else {
        vmrating.ratingMinutes = min;
      }
    } 
    vmrating.addNewChoice = function() {
      var createRandomHashVar = createRandomHash(10);
      vmrating.required[createRandomHashVar] = {};
      if(vmrating.selectedType.value === 'other') {
        vmrating.choices.push({'name': '','_id': createRandomHashVar});
      } else {
        vmrating.choices.push({'name': '','number':1,'_id': createRandomHashVar});
      }
    };
    var copyChoice = {};
    vmrating.editChoiceShow = {}
    vmrating.deleteOrCancelEditChoice = function(choice) {
      var index = vmrating.choices.findIndex(function(item) {
        return item._id === choice._id;
      });
      if(vmrating.editChoiceShow[choice._id]) {
        vmrating.choices[index] = copyChoice[choice._id];
        delete copyChoice[choice._id];
        delete vmrating.editChoiceShow[choice._id];
      } else {
        vmrating.choices.splice(index, 1);
        delete vmrating.required[choice._id];
        delete vmrating.editChoiceShow[choice._id];
      }
    }
    vmrating.editOrSaveChoice = function(choice) {
      copyChoice[choice._id] = angular.copy(choice);
      if(vmrating.editChoiceShow[choice._id]) {
        delete vmrating.editChoiceShow[choice._id];
      } else {
        vmrating.editChoiceShow[choice._id] = true;
      }
      vmrating.required[choice._id].name = false;
      vmrating.required[choice._id].number = false;
    }
    

    function actionWithRating() {
      var validation = true;
      if(!vmrating.dataRating.title) {
        vmrating.titleRequired = true;
        alertService('danger','Opps! ', 'Title is required');
        validation = false;
      } else {
        vmrating.titleRequired = false;
      }
      if(vmrating.choices.length < 2) {
        alertService('danger','Opps! ', 'At least two rating items are required');
        return;
      }
      var numberCounts = {};
      var duplicateFound = false;
      
      for(var i=0; i<vmrating.choices.length;i++) {
        if(!vmrating.choices[i].name) {
          alertService('danger','Opps! ', 'Name is required');
          vmrating.required[vmrating.choices[i]._id].name = true;
          validation = false;
        } else {
          vmrating.required[vmrating.choices[i]._id].name = false;
        }
        if(vmrating.selectedType.value !== 'other') {
          if(!vmrating.choices[i].number) {
            alertService('danger','Opps! ', 'If you select football or basketball, number is required');
            vmrating.required[vmrating.choices[i]._id].number = true;
            validation = false;
          } else {
            vmrating.required[vmrating.choices[i]._id].number = false;
            vmrating.choices[i].number = parseInt(vmrating.choices[i].number);
            
            // Check for duplicates in the same loop
            var num = vmrating.choices[i].number.toString();
            if(!numberCounts[num]) {
              numberCounts[num] = [];
            }
            numberCounts[num].push(i);
          }
        }
      }
      
      // Check for duplicates and mark them
      if(vmrating.selectedType.value !== 'other') {
        for(var num in numberCounts) {
          if(numberCounts[num].length > 1) {
            duplicateFound = true;
            // Mark all duplicates except the first one
            for(var j = 1; j < numberCounts[num].length; j++) {
              var choiceIndex = numberCounts[num][j];
              vmrating.required[vmrating.choices[choiceIndex]._id].duplicateNumber = true;
            }
          }
        }
        
        if(duplicateFound) {
          alertService('danger','Opps! ', 'Duplicate numbers are not allowed');
          validation = false;
        }
      }
      if(validation) {
        $rootScope.hasLoaded = false;
        var expire_date = null;
        if(vmrating.dataRating.status=='finish'){
          expire_date = $filter('date')(new Date().toISOString(), "MMM d, y HH:mm")
        } else if(vmrating.dataRating.status=='publish') {
          if(vmrating.dataRating.expire_date && new Date(vmrating.dataRating.expire_date).getTime() > new Date().getTime()) {
            expire_date = vmrating.dataRating.expire_date
          }
        }
        var updateData = {
          'title':vmrating.dataRating.title,
          'status': vmrating.dataRating.status,
          'type': vmrating.selectedType.value,
          'data':vmrating.choices,
          "expire_date": expire_date,
        }
        if(!parent) {
          var postFunction = function() {
            postDataService.save({
              param1:'ratings', 
            },updateData).$promise.then(function(postRating){
              $rootScope.hasLoaded = true;
              alertService('success','Success ', postRating.message, 2000);
              if(postRating && postRating.obj && postRating.obj._id) {
                $state.go('app.allratings',{id:postRating.obj._id});
              }
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                     postFunction();
                    }
                  },
                  function(error) {
                    // report something
                  },
                  function(progress) {
                   // report progress
                });
              } else if(error.status ==502) {
                serverError()
              } else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;  
            });
          }
          postFunction();
        } else {
          var putFunction = function() {
            putDataService.update({
              param1:'ratings', 
              param2:vmrating.dataRating._id
            },updateData).$promise.then(function(putRating){
                $rootScope.hasLoaded = true;
                populateData(putRating.obj)
                alertService('success','Success ', putRating.message, 2000);
            }, function(error){
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(error.status ==401) {
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                  function(answer) {
                    if(answer==200) {   
                      putFunction();
                    }
                  },
                  function(error) {
                    // report something
                  },
                  function(progress) {
                   // report progress
                });
              } else if(error.status ==502) {
                serverError()
              }else {
                alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;  
            });
          }
          putFunction();
        }
      }
    }
    vmrating.trashRating = function() {
      vmrating.dataRating.status = 'trash';
      vmrating.selectedRatingStatus = {value:'trash'};
      actionWithRating();
    }
    vmrating.publishRating = function() {
      vmrating.dataRating.status = 'publish';
      vmrating.selectedRatingStatus = {value:'publish'};
      actionWithRating();
    }
    vmrating.updateRating = function() {
      actionWithRating();
    }
    function populateData(data) {
      vmrating.update = false;
      vmrating.dataRating = data;
      vmrating.selectedType = {value: vmrating.dataRating.type};
      vmrating.choices = vmrating.dataRating.data;
      for(var i=0; i<vmrating.choices.length;i++) {
        vmrating.required[vmrating.choices[i]._id] = {};
      }
      vmrating.selectedRatingStatus.value = vmrating.dataRating.status;
      if(vmrating.dataRating.expire_date) {
        vmrating.dataRating.expire_date = $filter('date')(vmrating.dataRating.expire_date, "MMM d, y HH:mm");
        convertTimeFunction(vmrating.dataRating.expire_date);
      } else {
        convertTimeFunction(undefined);
      }
    }
    if(parent) {
      vmrating.ratingId = parent.ratingId;
      vmrating.newRating = false;
      $rootScope.closeEditRating = function() {
        $rootScope.ngEscapeAttrsParametars = [];
        parent.editRatingShow = false;
        vmrating.dataRating = null;
        $state.transitionTo('app.allratings', {id: null}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }
      var getRatingFunction = function() { 
        $rootScope.hasLoaded = false;
        getDataService.get({param1:'ratings', param2: vmrating.ratingId, param3:null}).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          populateData(data)
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError('refresh')
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                getRatingFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            parent.editRatingShow = false;
            vmrating.dataRating = null;
            $rootScope.hasLoaded = false;
            $state.transitionTo('app.allratings', {id: null}, {
              location: true,
              inherit: true,
              relative: $state.$current,
              notify: false
            });
          }
        });
      }
      getRatingFunction();
    } else {
      vmrating.newRating = true;
      vmrating.dataRating = {
        title: '',
        status: 'publish',
        data: [],
        expire_date: null,
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/ratingModule/edit-newrating/js/ratingController.js
// module id = 577
// module chunks = 0